// Mapa slug → presentación. Los logos viven en el front (Figma).
// El display_name preferente viene del payload (edition.brand); esto es el fallback + logo + color.
import radariaLogo from "@/assets/radaria-logo.svg";
import radarmktLogo from "@/assets/radarmkt-logo.svg";
import radarWordmark from "@/assets/radar-wordmark.svg";

export interface Branding {
  logo: string;
  accentColor: string;
  fallbackName: string;
}

const BRANDING: Record<string, Branding> = {
  radaria: { logo: radariaLogo, accentColor: "#1B998B", fallbackName: "RADAR IA" },
  radarmkt: { logo: radarmktLogo, accentColor: "#0A66C2", fallbackName: "RADAR AD" },
};

const DEFAULT: Branding = {
  logo: radarWordmark,
  accentColor: "#111827",
  fallbackName: "Radar",
};

export function getBranding(slug: string | null | undefined): Branding {
  if (!slug) return DEFAULT;
  return BRANDING[slug] ?? DEFAULT;
}
